// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import ColorConstants from 'constants/ColorConstants';
import SearchResultUtil from 'utils/SearchResultUtil';
import { useTranscriptName } from 'hooks/transcripts/queries';
const SearchResult = ({ match, transcriptID }) => {
  const { data: transcript } = useTranscriptName(transcriptID);
  
  const urlString = encodeURI(match.replace(/<strong>/g, "").replace(/<\/strong>/g, ""));
  const link = "/transcripts/" + transcriptID + "?search=" + urlString;
  
  const text = SearchResultUtil.renderHighlightedText(match);
  const name = transcript?.name || "Untitled";

  return (
    <div style={{ marginBottom: 20 }}>
      <Link to={link}>
        <span style={{ color: ColorConstants.ACTIVE_BUTTON_BLUE, fontSize: ".8em" }}>
          <strong>
            {name}
          </strong>
        </span>
      </Link>

      <div>
        <p>
          {text}
        </p>
      </div>
    </div>
  );
};

export default SearchResult;